import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

function Input({ placeholder, type = "text", name }) {
  return (
    <input
      type={type}
      name={name}
      placeholder={placeholder}
      required={placeholder.includes("*")}
      className="w-full bg-transparent border-b border-white placeholder-white/80 focus:outline-none py-2"
    />
  );
}

function Textarea({ placeholder, name }) {
  return (
    <textarea
      name={name}
      placeholder={placeholder}
      rows="4"
      required
      className="w-full bg-transparent border-b border-white placeholder-white/80 focus:outline-none py-2 resize-none"
    />
  );
}

export default function ContactSection() {
  const formRef = useRef();
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("success"); // success | error

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_64kl83u",
        "template_q5fmyms",
        formRef.current,
        "QYUj0KN-_lYaJ1rhX"
      )
      .then(
        () => {
          setModalType("success");
          setShowModal(true);
          formRef.current.reset();
        },
        () => {
          setModalType("error");
          setShowModal(true);
        }
      );
  };

  return (
    <>
      <section className="bg-[#92abc4]/85 text-white py-20 px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-center text-4xl font-extrabold mb-16">
            GET <span className="italic text-yellow-400">in</span> TOUCH!
          </h2>

          <form ref={formRef} onSubmit={sendEmail} className="space-y-10">
            <Input name="first_name" placeholder="Your First Name" />
            <Input name="last_name" placeholder="Your Last Name*" />
            <Input name="email" placeholder="Your Email*" type="email" />
            <Input name="contact" placeholder="Your Contact Number*" />
            <Textarea name="message" placeholder="Your Message*" />

            <div className="text-center">
              <button
                type="submit"
                className="bg-black text-white px-10 py-3 rounded-full font-semibold hover:bg-gray-900 transition"
              >
                SUBMIT
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 max-w-sm w-full text-center">
            <h3
              className={`text-2xl font-bold mb-4 ${
                modalType === "success" ? "text-green-600" : "text-red-600"
              }`}
            >
              {modalType === "success"
                ? "Message Sent!"
                : "Something went wrong"}
            </h3>

            <p className="text-gray-700 mb-6">
              {modalType === "success"
                ? "Thanks for reaching out. We’ll get back to you shortly."
                : "Please try again later or contact us directly."}
            </p>

            <button
              onClick={() => setShowModal(false)}
              className="bg-black text-white px-6 py-2 rounded-full hover:bg-gray-900 transition"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
}
